import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18next'

export function DefaultAddressSection({
  isDefaultDelivery,
  onDeliveryChange,
  isDefaultBilling,
  onBillingChange,
}) {
  return (
    <div className="address-section default-address-section">
      <h3 className="address-section-title">
        {t('ADDRESS_FORM_T.DEFAULT_SECTION_TITLE')}
      </h3>
      <label className="default-address-option">
        <input
          type="checkbox"
          checked={isDefaultDelivery}
          onChange={e => onDeliveryChange(e.target.checked)}
        />
        <div>
          <span className="default-address-option-label">
            {t('ADDRESS_FORM_T.DEFAULT_DELIVERY_LABEL')}
          </span>
          <span className="default-address-option-description">
            {t('ADDRESS_FORM_T.DEFAULT_DELIVERY_DESCRIPTION')}
          </span>
        </div>
      </label>
      <label className="default-address-option">
        <input
          type="checkbox"
          checked={isDefaultBilling}
          onChange={e => onBillingChange(e.target.checked)}
        />
        <div>
          <span className="default-address-option-label">
            {t('ADDRESS_FORM_T.DEFAULT_BILLING_LABEL')}
          </span>
          <span className="default-address-option-description">
            {t('ADDRESS_FORM_T.DEFAULT_BILLING_DESCRIPTION')}
          </span>
        </div>
      </label>
    </div>
  )
}

DefaultAddressSection.propTypes = {
  isDefaultDelivery: PropTypes.bool.isRequired,
  onDeliveryChange: PropTypes.func.isRequired,
  isDefaultBilling: PropTypes.bool.isRequired,
  onBillingChange: PropTypes.func.isRequired,
}
